import { Step } from "driver.js";

const workbench: Step[] = [
  {
    element: ".guideNotice",
    popover: {
      title: "新消息提醒",
      description: "点击待处理事项，即可进入事项处理页面",
      position: "left",
      // offset: 5,
    },
  },
  {
    element: "#inputHeader",
    popover: {
      title: "企业名称",
      description: "点击”企业名称“，即可切换企业",
    },
  },
  {
    element: "#guideToggle",
    popover: {
      title: "页面切换",
      description: "此处可进行切换操作页面",
    },
  },
  {
    element: "#guideNav",
    popover: {
      title: "系统功能",
      description: "点击系统模块，即可查看明细信息",
      position: "right",
    },
  },
  {
    element: "#guideEnter",
    popover: {
      title: "进入企业",
      description: "点击“进入企业”，即可跳转至企业操作系统，进行下一步业务处理啦",
    },
  },
  {
    element: "#guideIcon",
    popover: {
      title: "收起位置",
      description: "新手引导收起到此位置，有需要可以继续点击查看哦",
      position: "left",
    },
  },
];

const manage = [
  {
    element: "#mageageIcon",
    popover: {
      title: "页面切换",
      description: "此处可进行切换操作页面",
      position: "left",
      offset: 20,
    },
  },
];

// export const stepsWorkbench = workbench;
// const len = manage.length + workbench.length;
// export const stepsAll: Step[] = [];
// for (let i = 0; i < len; i++) {
//   const o = [...manage, ...workbench][i];
//   o.popover.title = `第${i + 1}步`;
//   stepsAll.push(o);
// }

export const getStepsArr = (isManager: boolean, isPlatform: boolean, isEnd = false): Step[] => {
  const arr = [];
  if (isEnd) return [workbench[workbench.length - 1]];
  if (isManager) arr.push(...manage);
  if (isPlatform) arr.push(...workbench);
  console.log(arr);

  return arr;
};
